import { createAsyncThunk } from "@reduxjs/toolkit";
import { signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword } from "firebase/auth";
import apiServices from "src/api/apiService";
import { auth } from "src/authentication/firebase";
// import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth"


export const loginUser = createAsyncThunk(
    'auth/loginUser',
    async ({ email, password }, { rejectWithValue }) => {
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const idToken = await userCredential.user.getIdToken();
            const user = {
                email: userCredential.user.email,
                uid: userCredential.user.uid,
            };
            return { idToken, user };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const logoutUser = createAsyncThunk('auth/logoutUser', async (_, { rejectWithValue }) => {
    try {
        await signOut(auth);
        return true; // Return a value indicating success
    } catch (error) {
        return rejectWithValue(error.message);
    }
});


export const signUp = createAsyncThunk('auth/signUp', async ({username, email, password}, {getState, rejectWithValue}) => {
    let currentState = getState();
    if(currentState.auth.user != null){
        return rejectWithValue("You are already signed in");
    }

    try {
        await apiServices.auth.usernameCheck(username);
        //Assume the username is valid at this point.
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const idToken = await userCredential.user.getIdToken();
        const user = {
            email: userCredential.user.email,
            uid: userCredential.user.uid,
        };
        const data = await apiServices.auth.signUp(username, idToken);
        const userData = await apiServices.auth.getMyUserData(idToken);
        return { idToken, user, userData };
      } catch (error) {
        return rejectWithValue(error.message);
      }
});

export const getUserData = createAsyncThunk('auth/getUserData', async (_, {getState, rejectWithValue}) => {
    let currentState = getState();
    
    try {
        const userData = await apiServices.auth.getMyUserData(currentState.auth.user.idToken);
        return userData;
      } catch (error) {
        return rejectWithValue(error.message);
      }
});